import { ColorEnum } from '@/constants/color'
import { FC } from 'react'
import Svg, { ClipPath, Defs, G, Path, Rect, SvgProps } from 'react-native-svg'

const BackspaceIcon: FC<SvgProps> = ({ color, fill = ColorEnum.VIOLET_200, ...props }) => {
    const iconColor = color ?? fill

    return (
        <Svg viewBox="0 0 22 18" width={22} height={18} fill="none" {...props}>
            <G clipPath="url(#backspace-clip)">
                <Path
                    d="M17.1476 5.875C17.1476 5.6375 17.0625 5.425 16.9044 5.25C16.7463 5.0875 16.5274 4.9875 16.2963 4.9875C16.0652 4.9875 15.8585 5.075 15.6882 5.2375L13.2559 7.75L10.8115 5.2375C10.6534 5.075 10.4345 4.975 10.2034 4.975C9.97236 4.975 9.76562 5.0625 9.60752 5.2375C9.44942 5.4 9.35213 5.625 9.35213 5.8625C9.35213 6.1 9.43726 6.3125 9.60752 6.4875L12.0398 8.9875L9.59536 11.4875C9.43726 11.65 9.33997 11.875 9.33997 12.1C9.33997 12.3375 9.4251 12.55 9.5832 12.725C9.74129 12.8875 9.9602 12.9875 10.1913 12.9875C10.4223 12.9875 10.6291 12.9 10.7993 12.725L13.2438 10.225L15.6761 12.725C15.8342 12.8875 16.0531 12.9875 16.2841 12.9875C16.5152 12.9875 16.7219 12.9 16.8922 12.725C17.0503 12.5625 17.1476 12.3375 17.1354 12.1C17.1354 11.8625 17.0503 11.65 16.88 11.4875L14.4478 8.9875L16.88 6.4875C17.0381 6.325 17.1354 6.1 17.1354 5.8625L17.1476 5.875Z"
                    fill={iconColor}
                />
                <Path
                    d="M19.3245 0H8.28192C7.50359 0 6.76175 0.35 6.25097 0.9625L0.352681 8.025C-0.121614 8.5875 -0.121614 9.4125 0.352681 9.975L6.23881 17.0375C6.74959 17.65 7.49143 18 8.26976 18H19.3123C20.7839 18 21.9878 16.7625 21.9878 15.25V2.75C21.9878 1.2375 20.7839 0 19.3123 0H19.3245ZM19.3245 16.25H8.28192C8.00221 16.25 7.7225 16.125 7.54008 15.9L1.78773 9L7.54008 2.1C7.7225 1.875 7.99005 1.75 8.28192 1.75H19.3245C19.8596 1.75 20.2974 2.2 20.2974 2.75V15.25C20.2974 15.8 19.8596 16.25 19.3245 16.25Z"
                    fill={iconColor}
                />
            </G>
            <Defs>
                <ClipPath id="backspace-clip">
                    <Rect width={22} height={18} fill={ColorEnum.WHITE} />
                </ClipPath>
            </Defs>
        </Svg>
    )
}

export default BackspaceIcon
